type SlidePreviewProps = {
  html: string
  css?: string
  title?: string
  className?: string
}

function previewSrcDoc(html: string, css: string): string {
  const styles = `html,body{margin:0;padding:1.25rem;font-family:system-ui,sans-serif;background:#fff;color:#111;}`
  return `<!doctype html><html><head><meta charset="utf-8"><style>${styles}</style><style>${css}</style></head><body>${html}</body></html>`
}

/** Sandboxed HTML/CSS preview — never same-origin innerHTML on the UI shell. */
export function SlidePreview({ html, css = '', title = 'Slide preview', className }: SlidePreviewProps) {
  return (
    <iframe
      title={title}
      sandbox=""
      srcDoc={previewSrcDoc(html, css)}
      className={className ?? 'h-full min-h-64 w-full rounded-md border border-border bg-background'}
    />
  )
}
